import { Link, useLocation } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function Header() {
  const { pathname } = useLocation();
  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-30 bg-white border-b-2 border-black"
    >
      <div className="flex items-center justify-between px-6 md:px-12 py-4">
        <Link
          to="/"
          data-testid="logo-link"
          className="flex items-center gap-3 group"
        >
          <div className="w-9 h-9 bg-black flex items-center justify-center text-white">
            <Sparkles className="w-5 h-5" strokeWidth={2.5} />
          </div>
          <div className="leading-none">
            <div className="font-display text-xl tracking-tighter">
              FORGE/01
            </div>
            <div className="label-eyebrow text-muted-foreground mt-1">
              AI IMAGE GALLERY
            </div>
          </div>
        </Link>
        <nav className="flex items-center gap-2 md:gap-6">
          <Link
            to="/"
            data-testid="nav-create"
            className={`label-eyebrow px-3 py-2 border-2 transition-colors ${
              pathname === "/"
                ? "bg-black text-white border-black"
                : "border-transparent hover:border-black"
            }`}
          >
            Create
          </Link>
          <Link
            to="/about"
            data-testid="nav-about"
            className={`label-eyebrow px-3 py-2 border-2 transition-colors ${
              pathname === "/about"
                ? "bg-black text-white border-black"
                : "border-transparent hover:border-black"
            }`}
          >
            About
          </Link>
        </nav>
      </div>
    </header>
  );
}
